import React, { Suspense } from 'react';
import PropTypes from 'prop-types';

import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchReportsWrapper = React.lazy(() => import('./match-reports'));

export interface IDynamicMatchReports {
  model: any;
  query?: {};
  children?: React.ReactNode;
  live?: boolean;
}

// TODO ADD use Service if component need to do Query or Subs
const DynamicMatchReports: React.FC<IDynamicMatchReports> = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}) => {
  return (
    <Suspense fallback={<HtmlWrapper html={children} />}>
      <MatchReportsWrapper live={live} initialModel={model} query={query} />
    </Suspense>
  );
};

DynamicMatchReports.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  live: PropTypes.bool,
  model: PropTypes.any,
  query: PropTypes.object,
};

/**
 * YOU need to specify default props to be derived from web-component attributes
 */
DynamicMatchReports.defaultProps = {
  children: null,
  model: {},
  query: {},
  live: false,
};

export default DynamicMatchReports;
